import {
    getDetectionConfig,
    getDetectionThreshold,
    updateDetectionConfig,
    updateDetectionThreshold
} from "./api";
import { CareRecipientId } from "../../../domain/care_recipient/CareRecipientId";
import { UserId } from "../../../domain/user/UserId";
import { DetectionConfig } from "../../../domain/detection/config/DetectionConfig";
import { DetectionThreshold } from "../../../domain/detection/config/DetectionThreshold";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { orderErrorToast, orderSuccessToast } from "../../../app/funcs/orderResultToast";

export const ActionType = Object.freeze({
    base: "@@Monitoring/Action/DetectionConfig",
    getConfig: "getConfig",
    getThreshold: "getThreshold",
    updateConfig: "updateConfig",
    updateThreshold: "updateThreshold"
});

export const getDetectionConfigAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getConfig}`,
    async(data: {
        userId: UserId,
        careRecipientId: CareRecipientId
    }, { rejectWithValue }) => {
        const response = await getDetectionConfig(data.userId, data.careRecipientId);

        if (response.error === undefined) {
            // API処理結果正常の場合
            return { ...response };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const getDetectionThresholdAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getThreshold}`,
    async(data: {
        userId: UserId,
        careRecipientId: CareRecipientId
    }, { rejectWithValue }) => {
        const response = await getDetectionThreshold(data.userId, data.careRecipientId);

        if (response.error === undefined) {
            // API処理結果正常の場合
            return { ...response };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const updateDetectionConfigAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.updateConfig}`,
    async(data: {
        userId: UserId,
        careRecipientId: CareRecipientId,
        config: DetectionConfig
    }, { rejectWithValue }) => {
        const response = await updateDetectionConfig(
            data.userId,
            data.careRecipientId,
            data.config
        );
    
        if (response.error === undefined) {
            // API処理結果正常の場合
            orderSuccessToast("通知設定を更新しました");
            return {};
        } else {
            // API処理結果異常の場合
            orderErrorToast("通知設定の更新に失敗しました");
            return rejectWithValue({});
        }
    }
);

export const updateDetectionThresholdAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.updateThreshold}`,
    async(data: {
        userId: UserId,
        careRecipientId: CareRecipientId,
        threshold: DetectionThreshold
    }, { rejectWithValue }) => {
        const response = await updateDetectionThreshold(
            data.userId,
            data.careRecipientId,
            data.threshold
        );
    
        if (response.error !== undefined) {
            // API処理結果異常の場合
            orderErrorToast("高音・低音通知設定の更新に失敗しました");
            return rejectWithValue({});
        }
    }
);
